<template>
  <v-container>
    <v-data-table
          v-bind:headers="headers"
          :items="items"
          :hide-default-footer="true"
          class="elevation-1"
          :no-data-text="$t('common.noDevicesConnected')"
        >
           <template v-slot:item="{ item }">
           <tr @click="Grafici()">
                <td v-if="item.name == 'Dispenser sapone'" ><img style="max-width: 80px;" src="../assets/dispenser_sapone_black_2.png" /></td>
                <td v-if="item.name == 'Dispenser asciugamano a rotolo'" ><img style="max-width: 60px;" src="../assets//6468588_roll_towel_paper_tissue_dispenser.png" /></td>
                <td v-if="item.name == 'Dispenser asciugamano'" ><img style="max-width: 60px;" src="../assets/6468584_paper_hand_towel_tissue_dispenser.png" /></td>
                <td v-if="item.name == 'Rotolo jumbo uomini'" ><img style="max-width: 60px;" src="../assets/toilet_paper.png" /></td>
                <td><v-icon :style="item.stato == 'red' ? 'color: red;' : 'color: green;'">mdi-checkbox-blank-circle</v-icon></td>
                <td>{{ item.name }}</td>
                <td>{{ item.building }}</td>
                <td>{{ item.piano }}</td>
                <td><v-icon :style="item.signal == 'ko' ? 'color: red;' : 'color: green;'" >mdi-wifi</v-icon></td>
           </tr>
           </template>
        </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: 'HomeView',
  data(){
    return{
      pagination: { 'sortBy': 'name', 'descending': true, rowsPerPage: 25 },
      selected: [],
      items: [{ name: "Dispenser asciugamano a rotolo", piano: "terzo piano", building: "YouTissue", stato: "green", signal: "ok"},
               {name: "Dispenser sapone",  piano: "primo piano", building: "YouTissue", stato: "red", signal: "ok"},
               {name: "Dispenser asciugamano", piano: "terzo piano", building: "YouTissue", stato: "green", signal: "ko"},
               {name: "Rotolo jumbo uomini", piano: "terzo piano", building: "YouTissue", stato: "green", signal: "ko"}],
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('manageSensors.type'), align: "center", value: "type"},
        { text: this.$t('sensorDetails.status'), align: "center", value: "stato" },
        { text: this.$t('manageSensors.name'), align: "center", value: "name" },
        { text: this.$t('manageSensors.building'), align: "center", value: "building" },
        { text: this.$t('manageSensors.floor'), align: "center", value: "piano" },
        { text: "Signal", align: "center", value: "signal" } 
      ]
    }
  },
  methods: {
    Grafici(){
      this.$router.push({ path: `/grafici` });
    }
  }
}
</script>
